import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

export default function activeConsultantListReducer(
  state = InitialState.activeConsultants,
  action
) {
  switch (action.type) {
    case types.LOAD_ACTIVE_CONSULTANT_LIST_SUCCESS:
      return action.consultants;
    default:
      return state;
  }
}
